export default __webpack_public_path__ + "static/media/IMG_1658483535767_1658496775967.a661ca65.jpg";